import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from '../DemolitionServices/DemolitionServices.module.scss';
import { CivilServicesRoomDetails } from "./CivilWorkConstant";
import DemolitionServicesOptions from '../DemolitionServices/DemolitionServicesOptions';
import { saveUpdatedPageDetails, saveMetaDataUpdate } from "../../../actions/wizard";

const CivilWorkServices = (props:any) => {
  const dispatch = useDispatch();
  const { isDrawingsExporting } = props;  
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);
  const requiredMetaDataUpdate = useSelector((state: any) => state.wizard.requiredMetaDataUpdate);
  const orderProfileTitle = useSelector((state: any) => state.wizard.orderProfileTitle);

  const latestStateRef = useRef(requiredMetaDataUpdate);

  const [updatedValues, setUpdatedValues] = useState(pageDetails);

  useEffect(() => {
    setUpdatedValues(pageDetails)
  }, [pageDetails]);


  // Update the meta details while unmounting.
  useEffect(() => {
    return () => {
      updateDetailsInMeta(false);
    }
  }, [])

  // Updating Item details in meta data
  const updateItems = (details: any) => {
    const updatedObj: any = {
      ...updatedValues,
      metaData: {
        ...updatedValues?.metaData,
        [details.id]: details.value
      }
    };
    setUpdatedValues(updatedObj)
    dispatch(saveMetaDataUpdate(updatedObj))
  }

  // Save function to save details in API
  const updateDetailsInMeta = (required: boolean) => {  
    if (latestStateRef.current) {
      dispatch(saveUpdatedPageDetails(latestStateRef.current, required));
      dispatch(saveMetaDataUpdate(false))
    }
  }

  // Created a debounce to update the exiting quote details 
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      updateDetailsInMeta(true);
    }, 4000); // Adjust the delay (in milliseconds) as needed

    latestStateRef.current = requiredMetaDataUpdate;

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [requiredMetaDataUpdate]);

  return (
    <section className={style.demolition_room_container}>
      <h2 className="section_heading">Civil Services - Drawing Details to be provided at Room Level; Quotation at Project Level</h2>
      <div className={style.demolition_details_tabs}>
        <div className={style.site_image_columns}>
          <section>
            <p>Key Plan of the House with Room Tagging</p>
          </section>
          <section>
            <div>
              <h4>Site Photograph 1</h4>
              <p>showing</p>
              <p>a) Details for all Civil requirements within the room - with Dimensions and Annotations explaining Civil Work</p>
            </div>
          </section>
          <section>
            <div>
              <h4>Site Photograph 2</h4>
              <p>showing</p>
              <p>a) Details for all Civil requirements within the room - with Dimensions and Annotations explaining Civil Work</p>
            </div>
          </section>
        </div>
        {
          updatedValues?.civilWorkDetails?.length ?
            <div className={style.demolition_item_container}>
              <h2 className="sub_tab_heading">CIVIL</h2>
              <div className={style.demolition_item_details}>
                <div className={style.demolition_items_heading}>
                  <h4>Civil Scope of Work</h4>
                  <h4>Quantity</h4>
                  <h4>UOM</h4>
                </div>
                {
                  updatedValues?.civilWorkDetails?.map((e, i) => (
                    <div className={style.demolition_items_list}>
                      <p>{e?.name}</p>
                      <p>{e?.qty}</p>
                      <p>{e?.uom}</p>
                    </div>
                  ))
                }
              </div>
            </div> : ''
        }
        <div className={style.demolition_sow}>
          <h2 className="sub_tab_heading">SCOPE OF CIVIL WORK in {orderProfileTitle} Scope (Room Level)</h2>
          <div className={style.sow_options_list}>
            {
              CivilServicesRoomDetails?.map((e, i) => (
                <div key={i} className={style.options_tab_vew}>
                  <p>{e?.label}</p>
                  <DemolitionServicesOptions details={e} optionsList={e?.options} isDrawingsExporting={isDrawingsExporting} updateDetails={(e) => updateItems(e)} itemDetails={updatedValues?.metaData} />
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </section>
  )
}

export default CivilWorkServices;